<template>
  <div>
    <van-popup v-model:show="show" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="timeConfirm"
        @cancel="timeCancel"
        @change="timechange"
        type="datetime"
        title="选择完整时间"
        :filter="filter"
      />
    </van-popup>
  </div>
</template>

<script>
import moment from 'moment'
import { reactive, toRefs, watch, ref } from 'vue'
import { getDateArr, cutTime, defaultTime } from '@/api/orderScheduledAt'
export default {
  props: {
    showCalendar: {
      default: 0,
      type: Number
    },
    earliest: {
      default: '',
      type: String
    },
    dealerInven: {
      default: () => {},
      type: Object
    }
  },
  setup(props, { emit }) {
    const currentDate = ref(new Date())
    let { showCalendar, earliest, dealerInven } = toRefs(props)
    const state = reactive({
      showCalendar,
      earliest,
      dealerInven,
      show: false,
      currentDate: currentDate,
      minDate: new Date(),
      maxDate: new Date(2025, 10, 1),
      minuteArr: ['00', '30'],
      hourArr: []
    })
    watch(
      () => state.showCalendar,
      data => {
        state.show = true
        if (data) {
          state.currentDate = moment(state.earliest).format('YYYY/MM/DD HH:mm')
        }
      }
    )
    watch(
      () => state.earliest,
      data => {
        let lastest = moment(data)
          .add(30, 'days')
          .format('YYYY/MM/DD HH:mm')
        let arr1 = getDateArr(data)
        let arr2 = getDateArr(lastest)
        // let aa = new Date(arr1[0], arr1[1] - 1, arr1[2], 10, 55);
        state.minDate = new Date(...arr1)
        state.maxDate = new Date(...arr2)
        // state.maxDate = new Date(arr2[0], arr2[1] - 1, arr2[2]);
        // state.minDate = aa;
      }
    )
    const filter = (type, options) => {
      if (type === 'hour') {
        return state.hourArr
      }
      if (type === 'minute') {
        return state.minuteArr
      }
      return options
    }
    const timeConfirm = () => {
      let data = defaultTime(moment(state.currentDate).utcOffset(8 * 60))
      state.show = false
      emit('setAppointTime', data)
    }
    const timeCancel = () => {
      state.show = false
    }
    const timechange = v => {
      let minute = moment(v).get('minute')
      // console.log('timechange--->', v, minute)
      minute = '' + minute
      minute = minute.length == 1 ? `0${minute}` : minute
      if (!state.minuteArr.includes(minute) && state.minuteArr.length === 1) {
        let resetDate = moment(new Date(v)).set({
          minute: state.minuteArr[0]
        })
        state.currentDate = new Date(resetDate)
      }
    }
    watch(
      () => state.currentDate,
      data => {
        let endArr = cutTime(state.dealerInven?.end_at, ':')
        let startArr = cutTime(state.dealerInven?.start_at, ':')
        let hour = new Date(data).getHours()
        let date = moment(data).format('YYYY-MM-DD')
        let minDate = moment(state.minDate).format('YYYY-MM-DD')
        let maxDate = moment(state.maxDate).format('YYYY-MM-DD')
        let minTime = cutTime(moment(state.minDate).format('HH:mm'), ':')
        let maxTime = cutTime(moment(state.maxDate).format('HH:mm'), ':')
        if (moment(date).isSame(moment(minDate))) {
          state.hourArr = [minTime[0]]
        } else if (moment(date).isSame(moment(maxDate))) {
          state.hourArr = [maxTime[0]]
        } else {
          let Hours = []
          for (let i = Number(startArr[0]); i <= Number(endArr[0]); i++) {
            i = '' + i
            i = i.length == 1 ? `0${i}` : i
            Hours.push(i)
          }
          state.hourArr = Hours
        }
        if (hour == endArr[0] && Number(endArr[1]) < 30) {
          state.minuteArr = ['00']
        } else if (hour == startArr[0] && Number(startArr[1]) > 0) {
          state.minuteArr = ['30']
        } else {
          state.minuteArr = ['00', '30']
        }
      }
    )
    return {
      ...toRefs(state),
      filter,
      timeConfirm,
      timeCancel,
      timechange
    }
  }
}
</script>
